module.exports = __webpack_public_path__ + "static/media/LogoCarnaval_Branca.705de952.png";